import styled from 'styled-components';

export interface IInputProps {
    isNotValid?: boolean;
}

export const CheckBoxInputWrapper = styled.div<IInputProps>`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: max-content;
    padding-left: 10px;

    ${({ isNotValid }) =>
        isNotValid &&
        `
    border-left: 3px solid #a94442; /* red */
  `}

    ${({ isNotValid }) =>
        !isNotValid &&
        `
    border-left: 3px solid #25982e; /* green */
  `}
  
  .checkbox-heading {
        height: 25px;
        background: #f4f4f4;
        .checkbox-heading-checkbox-arrow svg {
            height: 20px;
        }
    }

    .checkbox-content {
        label {
            padding: 5px;
            margin: 0;
            display: flex;
        }
        input {
            padding: 5px;
            margin: 0;
        }
        label.select-item {
            margin: 0 2px 0 0;
            font-weight: 500;
            font-size: 0.9rem;
            border-bottom: 1px solid #ddd;
            background: #eee;
        }
        .item-renderer > span {
            display: block;
            margin: 0;
            padding: 0;
            padding-left: 3px;
        }
    }
`;
